import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary';
import ShutdownLandingPage from './pages/ShutdownLandingPage';

/**
 * Minimal entry for the shutdown branch.
 * Avoids importing App.js (and its full product tree) so CRA can compile quickly.
 */
export default function ShutdownApp() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<ShutdownLandingPage />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
